import { PathTopic } from '../../data/builders/path_topic_builder';

export class TopicTileController {
  private topic: PathTopic;
  private isDisabled?: boolean;
  private optInCallback: (topic: PathTopic) => void;

  optIn(topic: PathTopic): void {
    if (!this.isDisabled) {
      topic.has_opted_in = !topic.has_opted_in;
      this.optInCallback(topic);
    }
  }
}

export class TopicTileComponent implements angular.IComponentOptions {
  public templateUrl: string = 'capability-ng-todos/src/components/topic_tile/topic_tile.html';
  public controller: any = TopicTileController;
  public controllerAs: string = '$ctrl';
  public bindings: any = {
    topic: '<',
    isDisabled: '<?',
    optInCallback: '&'
  };
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-todos/src/components/topic_tile/topic_tile.ts